export default function List(props) {
  return (
    <ul>
      {props.data.map((item, key) => (
        <li
          key={key}
          class='mx-auto overflow-hidden border-b border-gray-300 hover:bg-gray-300'
        >
          <a
            class='cursor-pointer p-4 block text-xl leading-tight w-full'
            onClick={() => props.onAction(item)}
          >
            {item}
            <svg
              className='w-5 h-5 float-right'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M9 5l7 7-7 7'
              />
            </svg>
          </a>
        </li>
      ))}
    </ul>
  );
}



// WEBPACK FOOTER //
// ./components/List.js